"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShapeDiverResponseModelComputationStatus = void 0;
const SdCommonModelComputation_1 = require("../commons/SdCommonModelComputation");
exports.ShapeDiverResponseModelComputationStatus = Object.assign({}, SdCommonModelComputation_1.ShapeDiverCommonsModelComputationStatus);
//# sourceMappingURL=SdResponseDtoModelComputation.js.map